// extracted by mini-css-extract-plugin
export default {"root":"activity_details_watchers-module___root___adf5fe7e"};